function testHostName(hostname: string, regExp: RegExp): boolean {
  return regExp.test(hostname);
}

export enum GenesysCloudDomains {
  local = 'maverick-local.bold360.io',
  dca = 'inindca.com',
  tca = 'inintca.com'
}

export const BoldDomains = [
  'bold360.com',
  'bold360.io'
];

export const APP_SUBDOMAIN_MATCHER = /apps\.|app\./;

export function isLocal(hostname = window.location.hostname) {
  return testHostName(hostname, new RegExp(GenesysCloudDomains.local)); // eslint-disable-line
}

export function isTCA(hostname = window.location.hostname) {
  return testHostName(hostname, new RegExp(GenesysCloudDomains.tca)); // eslint-disable-line
}

export function isDCA(hostname = window.location.hostname) {
  return testHostName(hostname, new RegExp(GenesysCloudDomains.dca)); // eslint-disable-line
}

export function isDXProd(hostname = window.location.hostname) {
  return !isLocal(hostname) && !isDCA(hostname) && !isTCA(hostname); // eslint-disable-line
}

export function isBold(hostname = window.location.hostname) {
  return BoldDomains.some(domain => testHostName(hostname, new RegExp(domain))); // eslint-disable-line
}
